import type { VipMembershipMode } from '$/store/useVipModalStore';

/**
 * 当前订阅信息由账号作用域决定，团队态后端等级比套餐等级多 1，校验前需对齐。
 */
export function getSubscribeLevelForMembershipMode(
  membershipMode: VipMembershipMode,
  subscribeLevel: number | undefined,
  isTeamSubscribeScope: boolean,
) {
  if (membershipMode === 'team') {
    return isTeamSubscribeScope && subscribeLevel ? subscribeLevel - 1 : undefined;
  }

  return isTeamSubscribeScope ? undefined : subscribeLevel;
}

/**
 * 当前订阅周期同样跟随账号作用域，避免团队周期误作用到个人商品。
 */
export function getSubscribeSubPeriodForMembershipMode(
  membershipMode: VipMembershipMode,
  subscribeSubPeriod: number | undefined,
  isTeamSubscribeScope: boolean,
) {
  if (membershipMode === 'team') {
    return isTeamSubscribeScope ? subscribeSubPeriod : undefined;
  }

  return isTeamSubscribeScope ? undefined : subscribeSubPeriod;
}

/**
 * 判断目标商品是否与当前会员作用域下的生效套餐完全一致，供按钮置灰和购买前拦截共用。
 */
export function isSameSubscribePlanForMembershipMode(
  membershipMode: VipMembershipMode,
  productLevel: number | undefined,
  productSubPeriod: number | undefined,
  subscribeLevel: number | undefined,
  subscribeSubPeriod: number | undefined,
  isTeamSubscribeScope: boolean,
) {
  const scopedSubscribeLevel = getSubscribeLevelForMembershipMode(
    membershipMode,
    subscribeLevel,
    isTeamSubscribeScope,
  );
  const scopedSubscribeSubPeriod = getSubscribeSubPeriodForMembershipMode(
    membershipMode,
    subscribeSubPeriod,
    isTeamSubscribeScope,
  );

  return Boolean(
    scopedSubscribeLevel
      && scopedSubscribeLevel >= 1
      && productLevel
      && productSubPeriod
      && scopedSubscribeSubPeriod
      && scopedSubscribeLevel === productLevel
      && scopedSubscribeSubPeriod === productSubPeriod,
  );
}
